import type { UiMessages } from "../types";

export const es: UiMessages = {
  nav: {
    streams: "En vivo",
    videos: "Videos",
    shorts: "Shorts",
    forYou: "Para ti",
    vr: "VR",
    cartoon: "Dibujos",
    hentai: "Hentai",
    sections: "Más",
    menu: "Menú",
    game: "Juego porno",
    stories: "Relatos eróticos",
    escorts: "Escorts",
    ai: "Novias IA",
    paysites: "Sitios premium",
    home: "Inicio",
    following: "Siguiendo",
    watching: "Viendo",
    rankings: "Ranking",
    invite: "Invitar amigos",
    coins: "Sweet Coin",
    achievements: "Logros",
    hot: "Lo más visto ahora",
    random: "Video aleatorio",
    saved: "Guardados",
    reacted: "Reacciones",
    boost: "Sweet Boost",
    premium: "Premium",
    stars: "Estrellas porno",
    productions: "Productoras",
    categories: "Categorías",
    telegram: "Canal de Telegram",
    allSections: "Todas las secciones",
    mainNavigation: "Navegación principal",
    quickNavigation: "Navegación rápida",
    show: "Mostrar",
    coinsReady: "Sweet Coins listas para recoger",
    logIn: "Iniciar sesión",
    search: "Buscar",
    closeSearch: "Cerrar búsqueda",
    language: "Idioma",
    theme: "Tema",
    themeDark: "Oscuro",
    themeLight: "Claro",
  },
  age: {
    parents: "Padres: nuestra página de {link} explica cómo bloquear el acceso a este sitio. Sweet lleva la etiqueta RTA.",
    parentalControls: "control parental",
    title: "Este es un sitio web para adultos",
    body: "Este sitio web contiene material restringido por edad, incluidos desnudos y representaciones explícitas de actividad sexual. Al entrar, confirmas que tienes al menos 18 años, o la mayoría de edad en la jurisdicción desde la que accedes al sitio, y que aceptas ver contenido sexualmente explícito.",
    enter: "Tengo 18 años o más — Entrar",
    exit: "Soy menor de 18 — Salir",
  },
  consent: {
    title: "Cookies",
    body: "Sweet es gratis gracias a los anuncios. Nuestros socios publicitarios usan cookies para mostrarlos y contar sus vistas y clics. El almacenamiento necesario, como tu confirmación de edad, funciona de todos modos.",
    privacy: "Política de privacidad",
    acceptAll: "Aceptar todo",
    onlyNecessary: "Solo las necesarias",
    settings: "Configuración de cookies",
  },
  ago: { now: "ahora", m: "{n} min", h: "{n} h", d: "{n} d", w: "{n} sem", mo: "{n} m", y: "{n} a" },
  cams: {
    allPlatforms: "Todas las plataformas",
    watchOnSite: "Ver en {site}",
    liveFor: "en vivo hace {time}",
    tryAnother: "Prueba otra etiqueta u otra región, o vuelve en un rato.",
    nobodyLiveOn: "Nadie está en vivo en {name} ahora mismo",
    platformShowUpHint: "Las transmisiones de {name} aparecen aquí en cuanto empiezan. Vuelve en un rato.",
    liveNowCount: "{n} en vivo ahora",
    opensOn: "se abren en {site}",
    streamerSite: "el sitio de la transmisión",
    orWatch: "O mira {link}.",
    videoTag: "videos de #{tag}",
    liveStreams: "Transmisiones en vivo",
    platformStreams: "Transmisiones en vivo de {name}",
    liveCams: "Cámaras en vivo",
    platformCams: "Cámaras de {name}",
    moreLiveCams: "Más cámaras en vivo",
    byTopic: "Cámaras en vivo por tema",
    breadcrumb: "Ruta de navegación",
    live: "En vivo",
    viewers: "Espectadores:",
    isLive: "{name} está en vivo",
    watchOn: "{title} — míralo en vivo en {site}",
    nobodyLive: "No hay nadie en vivo ahora mismo",
    noMatch: "Ninguna transmisión en vivo coincide con estos filtros",
    showUpHint: "Las transmisiones aparecen aquí en cuanto empiezan. Vuelve a echar un vistazo en un rato.",
    clearFilters: "Borrar filtros",
    clearAll: "Borrar todo",
    clear: "Borrar",
    seeAllPlatforms: "Ver todas las plataformas",
    watchVideos: "Ver videos",
    onPlatform: " en {name}",
    newOnTelegram: "Nuevas cámaras en vivo en Telegram",
    loadMoreFailed: "No se pudo cargar más; inténtalo de nuevo",
    platforms: "Plataformas",
    streamPlatforms: "Plataformas de streaming",
    platformsAndFilters: "Plataformas de streaming y filtros",
    categories: "Categorías",
    all: "Todos",
    region: "Región",
    allRegions: "Todas las regiones",
    more: "Más",
    newModels: "Modelos nuevos",
    tags: "Etiquetas",
    removeTag: "Quitar etiqueta",
    remove: "Quitar",
    loading: "Cargando",
    offline: "Desconectado",
    seeAll: "Ver todo",
    genders: { female: "Mujeres", male: "Hombres", couple: "Parejas", trans: "Trans" },
    regions: { north_america: "Norteamérica", south_america: "Sudamérica", europe: "Europa y Rusia", asia: "Asia", other: "Otras regiones" },
  },
  video: {
    fullScene: "Ver la escena completa en {site}",
    upNext: "A continuación",
    nextPage: "Página siguiente",
    moreVideos: "Más videos",
    end: "Has llegado al final.",
    loadMoreFailed: "No se pudo cargar más; inténtalo de nuevo",
    likes: "Me gusta",
    premiumVideo: "Video premium",
    subscribeToWatch: "Suscríbete para ver este video completo.",
    getPremium: "Hazte Premium",
    logIn: "Iniciar sesión",
    playsIn: "Se reproduce en el reproductor de {name}",
    partnerBlocked: "El vídeo se reproduce desde los servidores de {name}, que no responden desde tu red: puede que {name} esté bloqueado por tu proveedor de internet o en tu país.",
    unavailable: "{name} no reproduce sus videos en tu país, así que este no se puede ver aquí.",
    watchCams: "Mira cámaras en vivo",
    chatLive: "Chatea en vivo con {name} en {site}",
    play: "Reproducir {title}",
    sponsored: "Patrocinado",
    onlyfansCreators: "Creadoras de OnlyFans",
    liveNowFree: "En vivo ahora · gratis",
    allVideos: "Todos los videos",
    stoppedAt: "Te quedaste en {at} de {of}",
    watchedToEnd: "Visto hasta el final",
  },
  profile: { followers: "Seguidores", views: "Vistas", videos: "Videos", verified: "Verificado", follow: "Seguir", unfollow: "Dejar de seguir" },
  lists: {
    categories: "Categorías",
    popular: "Populares",
    aToZ: "A – Z",
    jumpToLetter: "Ir a la letra",
    allCategories: "Todas las categorías",
    noVideosYet: "Aún no hay videos aquí",
    pageN: "Página {n}",
    newEveryDay: "Cada día se añaden videos nuevos.",
    videoCount: "{n} videos",
    pornstars: "Estrellas porno",
    pornstarsIntro: "Las estrellas más seguidas esta semana.",
    studios: "Productoras porno",
    studiosIntro: "Productoras y canales, ordenados por seguidores.",
    noVideosWithTag: "No hay videos con esta etiqueta",
    showAllVideos: "Ver todos los videos",
  },
  hot: {
    title: "Lo más visto ahora",
    intro: "Los videos más vistos en Sweet en las últimas horas.",
  },
  comments: {
    title: "Comentarios",
    placeholder: "Escribe un comentario…",
    post: "Publicar",
    login: "Inicia sesión para comentar",
    coinsHint: "+{n} monedas por cada uno de tus primeros {max} comentarios del día",
    earned: "+{n} monedas",
    empty: "Aún no hay comentarios. Sé el primero.",
    more: "Ver más",
    delete: "Eliminar",
    short: "Escribe un poco más.",
    long: "Demasiado largo: {n} caracteres como máximo.",
    links: "No se permiten enlaces ni contactos en los comentarios.",
    forbidden: "Este comentario no se puede publicar.",
    rate: "Comentas demasiado rápido. Inténtalo más tarde.",
    duplicate: "Ya publicaste esto.",
    failed: "No se pudo publicar. Inténtalo de nuevo.",
    like: "Me gusta",
    dislike: "No me gusta",
    rateLogin: "Inicia sesión para valorar videos",
    liked: "Al {p}% le gusta",
  },
  starVote: {
    title: "Estrella del mes",
    vote: "Votar",
    voteFor: "Vota por {name} como estrella del mes",
    voteAgain: "Votar otra vez · {n} monedas",
    confirm: "¿Gastar {n} monedas?",
    standing: "N.º {rank} este mes · votos: {n}",
    noVotes: "Aún no hay votos este mes",
    thanks: "¡Gracias por tu voto!",
    paidThanks: "Voto contado · −{n} monedas",
    coins: "No tienes suficientes monedas: un voto cuesta {n}.",
    limit: "Ya usaste todos tus votos de hoy.",
    rules: "Un voto gratis al día; después, {n} monedas por voto.",
    boardIntro: "Los miembros votan por sus estrellas favoritas en sus páginas: un voto gratis al día y más por {n} monedas cada uno.",
    boardEmpty: "Aún no hay votos este mes. Vota por una estrella en su página.",
    votes: "Votos",
    lastWinner: "Estrella del mes pasado",
    login: "Inicia sesión para votar",
  },
  achievements: {
    title: "Logros",
    intro: "Desbloquea logros mientras ves, sigues y participas. Cada uno da Sweet Coins.",
    unlocked: "Desbloqueado",
    coins: "+{n} monedas",
    progress: "{x} de {n}",
    total: "{x} de {n} desbloqueados",
    login: "Inicia sesión para conseguir logros y sus monedas.",
    signup: "Crear cuenta",
    toast: "Logro desbloqueado",
    names: {
      "videos-1": ["Primer video", "Mira tu primer video"],
      "videos-10": ["Calentando", "Mira 10 videos"],
      "videos-100": ["Habitual", "Mira 100 videos"],
      "videos-1000": ["Experto", "Mira 1.000 videos"],
      "hours-1": ["Una hora", "Mira durante una hora"],
      "hours-10": ["Diez horas", "Mira durante 10 horas"],
      "hours-100": ["Maratón", "Mira durante 100 horas"],
      "streak-3": ["Tres seguidos", "Mira 3 días seguidos"],
      "streak-7": ["Racha semanal", "Mira todos los días durante una semana"],
      "streak-30": ["Racha mensual", "Mira todos los días durante 30 días"],
      "follows-5": ["Fan", "Sigue a 5 estrellas o productoras"],
      "likes-25": ["Gran corazón", "Dale me gusta a 25 videos"],
      "saves-10": ["Coleccionista", "Guarda 10 videos"],
      "days-7": ["Semana de monedas", "Recoge monedas 7 días"],
      "days-30": ["Mes de monedas", "Recoge monedas 30 días"],
      "invites-1": ["Trae a un amigo", "Invita a un amigo que se registre"],
      "comments-1": ["Primeras palabras", "Escribe tu primer comentario"],
      "comments-25": ["Conversador", "Escribe 25 comentarios"],
      "votes-1": ["Votante", "Vota por la estrella del mes"],
    },
  },
  pwa: {
    appName: "App de Sweet",
    bannerLabel: "Instalar la app",
    bannerPitch: "Pantalla completa, sin tienda de apps",
    install: "Instalar",
    notNow: "Ahora no",
    installApp: "Instalar la app",
    howToInstall: "Cómo instalarla",
    inApp: "Estás usando la app.",
    cardPitch: "Pantalla completa, a un toque desde tu pantalla de inicio. Sin tienda de apps.",
    manual: "Abre el menú del navegador y elige {install} o {add}.",
    iosTitle: "Añade Sweet a tu pantalla de inicio",
    iosShare: "Toca {share} en la barra del navegador (en iOS 26: {more} y luego {share})",
    iosAdd: "Elige {add}",
    iosConfirm: "Toca {confirm}: Sweet se abre a pantalla completa desde tu pantalla de inicio",
    share: "Compartir",
    more: "•••",
    add: "Añadir a pantalla de inicio",
    confirm: "Añadir",
    installMenu: "Instalar aplicación",
    gotIt: "Entendido",
    close: "Cerrar",
    offlineTitle: "Sin conexión",
    offlineBody: "Sweet necesita internet para reproducir videos y cams. Revisa tu conexión e inténtalo de nuevo.",
    retry: "Reintentar",
    recent: "Abiertas recientemente",
  },
  notifications: {
    title: "Notificaciones",
    empty: "Aún no hay novedades. Sigue estrellas y productoras o añade modelos de webcam a tus favoritos, y sus novedades aparecerán aquí.",
    newVideos: "Videos nuevos",
    liveNow: "En vivo ahora",
    markRead: "Marcar todo como leído",
    pushOn: "Activar notificaciones",
    pushOff: "Desactivar notificaciones",
    pushHint: "Entérate de los videos nuevos y de tus favoritos en vivo aunque Sweet esté cerrado.",
    pushBlocked: "Las notificaciones de Sweet están bloqueadas en la configuración de tu navegador.",
    pushUnsupported: "Este navegador no puede mostrar notificaciones. En iPhone, primero añade Sweet a tu pantalla de inicio.",
    pushEnabled: "Notificaciones activadas",
    favorites: "Modelos favoritas",
    addFavorite: "Añadir a favoritos",
    removeFavorite: "Quitar de favoritos",
    favoritesEmpty: "Aún no tienes modelos favoritas. Toca el corazón en una webcam para añadirla.",
    offline: "Desconectada",
    viewAll: "Ver todo",
  },
  forYou: {
    title: "Para ti",
    all: "Todo",
    continueWatching: "Seguir viendo",
    intro: "Elegidos según lo que te gusta, guardas, ves y sigues.",
    empty: "Dale me gusta, guarda o sigue algunos videos y estrellas, y aquí aparecerán videos elegidos para ti.",
    more: "Más",
  },
  shorts: {
    straight: "Hetero",
    gay: "Gay",
    trans: "Trans",
    watchFull: "Ver video completo",
    like: "Me gusta",
    liked: "Te gusta",
    save: "Guardar",
    saved: "Guardado",
    share: "Compartir",
    copied: "Enlace copiado",
    soundOn: "Activar sonido",
    soundOff: "Silenciar",
    tapForSound: "Toca para el sonido",
    report: "Denunciar",
    follow: "Seguir",
    following: "Siguiendo",
    previous: "Anterior",
    next: "Siguiente",
    close: "Cerrar",
    end: "Eso es todo por ahora. Más en Videos.",
    empty: "Aún no hay shorts aquí.",
    live: "En vivo",
    watchLive: "Ver en vivo gratis",
    watching: "{n} viendo",
    profile: "Perfil",
    moreLive: "Más cams en vivo",
  },
  search: {
    searches: "Búsquedas",
    popular: "Búsquedas populares",
    categories: "Categorías",
    searchFor: "Buscar videos de «{q}»",
    nothingFor: "No se encontró nada para «{q}».",
    title: "Buscar en Sweet",
    placeholder: "Busca videos, personas y marcas",
    hint: "Encuentra videos, estrellas, productoras y categorías. Pulsa / en cualquier parte para empezar a escribir.",
    stars: "Estrellas",
    productions: "Productoras",
    other: "Otros",
    otherProfiles: "Otros perfiles",
    nothing: "No se encontró nada",
    tryAgain: "Revisa la ortografía o prueba con un término más general.",
    backHome: "Volver al inicio",
  },
  notFound: { title: "Esta página no existe", body: "Puede que el video se haya eliminado o que el enlace esté mal escrito.", home: "Ir al inicio" },
  common: {
    close: "Cerrar",
    copy: "Copiar",
    copied: "Copiado",
    more: "Más",
    loading: "Cargando",
    clearAll: "Borrar todo",
    browseVideos: "Ver videos",
    scrollLeft: "Desplazar a la izquierda",
    scrollRight: "Desplazar a la derecha",
  },
  actions: {
    react: "Me gusta",
    reacted: "Te gusta",
    save: "Guardar",
    saved: "Guardado",
    follow: "Seguir",
    following: "Siguiendo",
    followName: "Seguir a {name}",
    unfollowName: "Dejar de seguir a {name}",
    moreOptions: "Más opciones",
    share: "Compartir",
    copyLink: "Copiar enlace",
    linkCopied: "Enlace copiado",
    report: "Denunciar",
    home: "Sweet — inicio",
    onSweet: "{name} en Sweet",
    joinMe: "Únete a mí en Sweet",
    inviteLink: "Tu enlace de invitación",
  },
  library: {
    savedEmpty: "Aún no has guardado nada",
    savedHint: "Toca el marcador debajo de cualquier video para guardarlo aquí. Tu lista se guarda solo en este dispositivo.",
    reactedEmpty: "Aún no hay reacciones",
    reactedHint: "Los videos que marcas con un corazón aparecen aquí, los más nuevos primero.",
    watchingEmpty: "Aún no has visto nada",
    watchingHint: "Los videos que reproduces aparecen aquí con el momento exacto en que paraste, y siguen desde ahí cuando los vuelves a abrir.",
    removeWatching: "Quitar del historial",
    removeVideo: "Quitar {title} del historial",
    followingEmpty: "Aún no sigues a nadie",
    followingHint: "Toca el + de una creadora o un estudio y sus videos más nuevos se reunirán aquí. Los seguidos se guardan solo en este dispositivo.",
    discoverModels: "Descubrir modelos",
    noVideosHint: "Prueba otra categoría: cada día se añaden videos nuevos.",
    backToAll: "Volver a todos los videos",
  },
  player: {
    resumesAt: "Continúa en {at}",
    startOver: "Empezar de nuevo",
    unavailable: "Este video no está disponible ahora mismo.",
    play: "Reproducir",
    pause: "Pausa",
    seek: "Buscar",
    back10: "Retroceder 10 segundos",
    forward10: "Avanzar 10 segundos",
    mute: "Silenciar",
    unmute: "Activar sonido",
    volume: "Volumen",
    settings: "Ajustes",
    pip: "Imagen en imagen",
    fullscreen: "Pantalla completa",
    exitFullscreen: "Salir de pantalla completa",
    quality: "Calidad",
    speed: "Velocidad de reproducción",
    normal: "Normal",
    auto: "Auto",
    partner: "el socio",
  },
  ads: { ad: "Anuncio", advertisement: "Publicidad", muteAd: "Silenciar anuncio", unmuteAd: "Activar sonido del anuncio", skipIn: "Saltar en {n}", skipAd: "Saltar anuncio ›" },
  auth: {
    username: "Nombre de usuario",
    usernameOrEmail: "Usuario o email",
    emailOptional: "Email (opcional)",
    password: "Contraseña",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirma la contraseña",
    confirmNewPassword: "Confirma la nueva contraseña",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
    forgot: "¿Olvidaste tu contraseña?",
    remember: "Mantener la sesión iniciada",
    logIn: "Iniciar sesión",
    createAccount: "Crear cuenta",
    usernameHelp: "De 3 a 24 letras, números, puntos o guiones bajos. Se muestra en el ranking.",
    emailHelp: "Solo se usa para restablecer tu contraseña. Puedes añadirlo más tarde en tu cuenta.",
    passwordHelp: "Al menos 8 caracteres.",
    adult: "Tengo 18 años o más.",
    agree: "Acepto los {terms} y la {privacy}.",
    terms: "Términos",
    privacy: "Política de privacidad",
    savePhrasesTitle: "Guarda tus frases de recuperación",
    savePhrasesBody: "Te registraste sin email, así que estas frases son tu forma de volver a entrar si olvidas la contraseña.",
    continue: "Continuar",
    resetHow: "Cómo restablecer tu contraseña",
    byEmail: "Enviarme un enlace",
    byPhrase: "Usar una frase de recuperación",
    phraseIntro: "Para cuentas creadas sin email: escribe tu nombre de usuario y cualquiera de las frases de recuperación que guardaste al registrarte.",
    phrase: "Frase de recuperación",
    phrasePlaceholder: "palabra palabra palabra palabra",
    phraseHelp: "Las 4 palabras de una frase. Cada frase sirve una sola vez.",
    saveNewPassword: "Guardar nueva contraseña",
    sendLink: "Enviar enlace de restablecimiento",
  },
  phrases: {
    warning: "Guárdalas ahora: no se volverán a mostrar. Si olvidas tu contraseña, tu nombre de usuario y cualquiera de estas frases te permiten elegir una nueva. Cada frase sirve una sola vez. No se las muestres a nadie.",
    list: "Tus frases de recuperación",
    copyAll: "Copiar todas",
    download: "Descargar .txt",
    savedCheck: "He guardado mis frases de recuperación en un lugar seguro.",
    done: "Listo",
    fileTitle: "Frases de recuperación de Sweet para @{username}",
    fileHow: "Si olvidas tu contraseña, ve a {url}, elige «{option}» y escribe tu nombre de usuario y cualquiera de estas frases.",
    filePrivate: "Cada frase sirve una sola vez. No se las muestres a nadie: quien tenga tu nombre de usuario y una de estas frases puede quedarse con tu cuenta.",
    none: "Tu cuenta no tiene email ni frases de recuperación. Si olvidas tu contraseña, no podrás volver a entrar. Crea frases de recuperación ahora.",
    optional: "Las frases de recuperación te permiten elegir una nueva contraseña sin email. Son opcionales mientras tu cuenta tenga un email.",
    left: "{left} de {total} frases sin usar.",
    leftMade: "{left} de {total} frases sin usar, creadas el {date}.",
    how: "Cada una, junto con tu nombre de usuario, te deja elegir una nueva contraseña una vez. ¿Las perdiste? Crea otras nuevas y las anteriores dejarán de funcionar.",
    make: "Crear frases de recuperación",
    makeNew: "Crear frases nuevas",
  },
  account: {
    menu: "Menú de la cuenta",
    settings: "Ajustes de la cuenta",
    profiles: "Tus perfiles",
    logOut: "Cerrar sesión",
    uploadPhoto: "Subir foto",
    removePhoto: "Quitar la foto actual",
    displayName: "Nombre visible",
    showInRankings: "Mostrarme en el ranking",
    rankingsHelp: "Tu nombre, tu foto y tus estadísticas de visualización aparecen en el {link} público. Desactívalo para no aparecer; tu tiempo se sigue contando.",
    save: "Guardar",
    emailHelp: "Solo se usa para enviarte un enlace si olvidas tu contraseña. Déjalo vacío para quitarlo.",
    saveEmail: "Guardar email",
    changePassword: "Cambiar contraseña",
    deleteWarning: "Esto borra para siempre tu cuenta, tus videos guardados, reacciones y seguidos. No se puede deshacer.",
    typeToConfirm: "Escribe {word} para confirmar",
    deleteMine: "Eliminar mi cuenta",
  },
  pay: {
    billingPeriod: "Periodo de facturación",
    monthly: "Mensual",
    yearly: "Anual",
    yourPlan: "Tu plan",
    month: "mes",
    year: "año",
    oneMonth: "1 mes",
    months: "{n} meses",
    oneYear: "1 año",
    years: "{n} años",
    perMonth: "{price} al mes",
    save: "Ahorra un {n}%",
    comingSoon: "Muy pronto",
    reward: "−{n}% tu recompensa",
    plays: "{n} partidas en Sweet Room",
    addedAtOnce: "Se añaden al instante",
    get: "Obtener {plan}",
    addMonth: "Añadir un mes",
    addYear: "Añadir un año",
    opensSoon: "Los pagos abren pronto",
    alreadyMember: "¿Ya eres miembro?",
    choose: "Elige cómo pagar",
    payWith: "Pagar con",
    starsInBot: "{n} Stars en nuestro bot de Telegram",
    card: "Tarjeta",
    crypto: "Cripto",
    cryptoMore: "BTC, USDT, ETH, TON y más de 30 más",
    tooManyStars: "Es demasiado para un solo pago con Telegram Stars.",
    cardMin: "Los pagos con tarjeta empiezan en {price}.",
    payStars: "Pagar con Telegram Stars",
    preparing: "Preparando tu pago…",
    loginFirst: "Primero inicia sesión",
    cantStart: "No se puede iniciar el pago",
    noAdsCoins: "Sin anuncios + {n} Sweet Coins",
    addedOnPay: "Se añaden a tu saldo en cuanto pagas",
    payInTelegram: "Pagar en Telegram",
    waitingStars: "Esperando tu pago: esta página se actualiza sola",
    allSet: "¡Todo listo!",
    noAds: "Sin anuncios.",
    noAdsUntil: "Sin anuncios hasta el {date}.",
    coinsAdded: "{n} monedas ya están en tu saldo.",
    startWatching: "Empezar a ver",
    great: "Genial",
    payCard: "Pagar con tarjeta",
    failedTitle: "El pago no se completó",
    failedBody: "No se ha cobrado nada. Puedes intentarlo de nuevo.",
    newTab: "Paga en la nueva pestaña",
    newTabBody: "Tarjeta, Apple Pay o Google Pay en la página segura de Chain2Pay. Esta página se actualiza sola en cuanto se pague.",
    waiting: "Esperando tu pago…",
    openAgain: "Abrir otra vez la página de pago",
    somethingWrong: "Algo salió mal. Inténtalo de nuevo en un minuto.",
    offline: "Parece que no tienes conexión. Inténtalo de nuevo en un minuto.",
    bestValue: "Mejor precio",
    coins: "monedas",
    orStars: "o {n} Stars",
    packsSoon: "Los paquetes de monedas salen a la venta muy pronto.",
    nCoins: "{n} Sweet Coins",
    collected: "¡+{n} Sweet Coins recogidas!",
    collectedToday: "Recogidas hoy",
    nextBonus: "Próximo bono en",
    collecting: "Recogiendo…",
    collect: "Recoger {n} Sweet Coins",
    alreadyCollected: "Ya recogiste las monedas de hoy. Vuelve mañana.",
    offerLabel: "Sweet Coins y Premium",
    offerTitle: "Consigue Sweet Coins",
    offerFor: "Para Sweet Room y videos de pago",
    premiumFrom: "Premium desde {price}",
    upTo: "Sin anuncios + hasta {n} monedas",
    packsFrom: "Paquetes de monedas desde {price}",
    collectFree: "O recoge monedas gratis cada día",
    offerButton: "Oferta de Sweet Coins",
    guestCollected: "¡+{n} Sweet Coins! Si no quieres perder tus monedas, regístrate en Sweet.",
    guestKeep: "Sin cuenta, las monedas se guardan {days} días y luego se pierden.",
    guestSignup: "Regístrate gratis y consérvalas",
    guestLogin: "¿Ya tienes cuenta? Inicia sesión",
    guestExpire: "{n} monedas se perderán el {date}.",
    guestUnsaved: "Tus monedas aún no están guardadas: regístrate para conservarlas",
    guestExpiring: "{n} de tus Sweet Coins se perderán en menos de un día. Regístrate gratis para conservarlas.",
  },
  footer: {
    copyright: "Derechos de autor",
    takedown: "Retirada de contenido",
    contact: "Contacto",
    creators: "Creadores",
    claim: "Reclama tu perfil",
    webmasters: "Webmasters",
    terms: "Términos",
    privacy: "Privacidad",
    info: "Información del sitio",
    telegram: "{site} en Telegram",
  },
  report: {
    heading: "Denunciar un video",
    reason: "Motivo",
    takedown: "Derechos de autor / DMCA",
    abuse: "Aparezco en este video sin mi consentimiento",
    minor: "Alguien en este video podría ser menor de 18 años",
    other: "Otra cosa",
    url: "Enlace o ID del video",
    email: "Tu email",
    details: "Detalles",
    detailsPlaceholder: "¿Qué debemos retirar y por qué?",
    send: "Enviar denuncia",
  },
};
